import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocale } from '../i18n/LocaleContext';
import { localePath, SUPPORTED_LANGUAGES } from '../i18n';
import './LanguageSwitcher.css';

const LABELS = { en: 'EN', ar: 'ع' };
const FULL_LABELS = { en: 'English', ar: 'العربية' };

/**
 * Switches language by navigating to the same page under the other language's
 * URL, so the choice is shareable and indexable rather than hidden in state.
 */
export default function LanguageSwitcher() {
  const { lang, canonicalPath } = useLocale();
  const navigate = useNavigate();

  return (
    <div className="lang-switcher" role="group" aria-label="Language">
      {SUPPORTED_LANGUAGES.map((code) => (
        <button
          key={code}
          type="button"
          className={`lang-option ${code === lang ? 'is-active' : ''}`}
          lang={code}
          aria-current={code === lang ? 'true' : undefined}
          title={FULL_LABELS[code]}
          onClick={() => navigate(localePath(canonicalPath, code))}
        >
          {LABELS[code]}
        </button>
      ))}
    </div>
  );
}
